import { PayloadAction } from '@reduxjs/toolkit';
import { errorMessages } from '~/constants/errorMessages.ts';
import {
  TRemoteBankingContactsStore,
  TValidateDocumentResponse,
} from '~/store/remote-banking-contacts/types.ts';

export const validateDocumentFulfilled = (
  state: TRemoteBankingContactsStore,
  action: PayloadAction<TValidateDocumentResponse>
) => {
  const signatureValid = action.payload.signatureValid;
  const identityMatched = action.payload.identityMatched;

  if (signatureValid === false) {
    state.loading = false;
    state.error = errorMessages.INVALID_SIGNATURE;
    return;
  }

  if (identityMatched === false) {
    state.loading = false;
    state.error = errorMessages.DATA_DOES_NOT_MATCH;
    return;
  }

  state.loading = false;
  state.error = null;
};

export const validateDocumentPending = (state: TRemoteBankingContactsStore) => {
  state.loading = true;
  state.error = null;
};
